export const CURRENCIES = [
    { country: "Afghanistan", code: "AFN", symbol: "؋" },
    { country: "Eurozone", code: "EUR", symbol: "€" },
    { country: "Albania", code: "ALL", symbol: "L" },
    { country: "Algeria", code: "DZD", symbol: "دج" },
    { country: "United States", code: "USD", symbol: "$" },
    { country: "Armenia", code: "AMD", symbol: "֏" },
    { country: "Aruba", code: "AWG", symbol: "ƒ" },
    { country: "Azerbaijan", code: "AZN", symbol: "₼" },
    { country: "Bahrain", code: "BHD", symbol: ".د.ب" },
    { country: "Bangladesh", code: "BDT", symbol: "৳" },
    { country: "Belarus", code: "BYN", symbol: "Br" },
    { country: "Bhutan", code: "BTN", symbol: "Nu." },
    { country: "Bolivia", code: "BOB", symbol: "Bs." },
    { country: "Bosnia and Herzegovina", code: "BAM", symbol: "KM" },
    { country: "Botswana", code: "BWP", symbol: "P" },
    { country: "Brazil", code: "BRL", symbol: "R$" },
    { country: "Bulgaria", code: "BGN", symbol: "лв" },
    { country: "Burundi", code: "BIF", symbol: "FBu" },
    { country: "Cambodia", code: "KHR", symbol: "៛" },
    { country: "China", code: "CNY", symbol: "¥" },
    { country: "Comoros", code: "KMF", symbol: "CF" },
    { country: "Costa Rica", code: "CRC", symbol: "₡" },
    { country: "Cuba", code: "CUP", symbol: "₱" },
    { country: "Czech Republic", code: "CZK", symbol: "Kč" },
    { country: "Djibouti", code: "DJF", symbol: "Fdj" },
    { country: "Dominican Republic", code: "DOP", symbol: "RD$" },
    { country: "Egypt", code: "EGP", symbol: "£" },
    { country: "Eritrea", code: "ERN", symbol: "Nfk" },
    { country: "Eswatini", code: "SZL", symbol: "E" },
    { country: "Ethiopia", code: "ETB", symbol: "Br" },
    { country: "Georgia", code: "GEL", symbol: "₾" },
    { country: "Ghana", code: "GHS", symbol: "₵" },
    { country: "Guatemala", code: "GTQ", symbol: "Q" },
    { country: "Guinea", code: "GNF", symbol: "FG" },
    { country: "Hungary", code: "HUF", symbol: "Ft" },
    { country: "Iceland", code: "ISK", symbol: "kr" },
    { country: "India", code: "INR", symbol: "₹" },
    { country: "Indonesia", code: "IDR", symbol: "Rp" },
    { country: "Iran", code: "IRR", symbol: "﷼" },
    { country: "Iraq", code: "IQD", symbol: "ع.د" },
    { country: "Israel", code: "ILS", symbol: "₪" },
    { country: "Japan", code: "JPY", symbol: "¥" },
    { country: "Jordan", code: "JOD", symbol: "د.ا" },
    { country: "Kazakhstan", code: "KZT", symbol: "₸" },
    { country: "Kenya", code: "KES", symbol: "KSh" },
    { country: "South Korea", code: "KRW", symbol: "₩" },
    { country: "Kuwait", code: "KWD", symbol: "د.ك" },
    { country: "Lebanon", code: "LBP", symbol: "ل.ل" },
    { country: "Malaysia", code: "MYR", symbol: "RM" },
    { country: "Pakistan", code: "PKR", symbol: "₨" },
    { country: "Poland", code: "PLN", symbol: "zł" },
    { country: "United Kingdom", code: "GBP", symbol: "£" }
];